import { render, staticRenderFns } from "./six2.vue?vue&type=template&id=65d306be&scoped=true&"
import script from "./six2.vue?vue&type=script&lang=js&"
export * from "./six2.vue?vue&type=script&lang=js&"
import style0 from "./six2.vue?vue&type=style&index=0&id=65d306be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d306be",
  null
  
)

export default component.exports